import React, { Suspense } from "react";

const PlatformSettingsPage = React.lazy(() => import("@/pages/platform-settings"));

export default function PlatformSettingsContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <PlatformSettingsPage />
    </Suspense>
  );
}
